import { render, staticRenderFns } from "./editCard.vue?vue&type=template&id=2be121d0&"
import script from "./editCard.vue?vue&type=script&lang=js&"
export * from "./editCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports